module.exports = __webpack_public_path__ + "img/frame (47).96e85f38.jpg";